export class LoginModel {
  public email?: string;
  public type?: string;
  public signin?: string;
  public password?: string;
  public rememberMe: boolean;
  public phoneNumber?: string;
  public validationMethod?: string;
}
